export default __webpack_public_path__ + "images/SpeakersPhotos/Alvaro de la Cueva Garrigues.jpg?d3cbd7d6";